<template>
  <div class="headContainer">
    <div class="headCon">
      <div class="time">{{ now }}</div>
      <div class="center">
        <div class="center_top">
          <div class="logo">
            <img width="100%" src="../../src/assets/logo.png" alt />
          </div>
          <div class="main_title">
            <img width="100%" :src="main_title" alt="" srcset="" />
          </div>
        </div>
      </div>
      <div class="weather">
        <span>当前天气：</span><span>{{ city }}</span
        ><span><!-- <img :src="img_src" /> --></span
        ><span>{{ weatherInfo.dayweather }}</span
        ><span>{{ weatherInfo.nighttemp }}℃~{{ weatherInfo.daytemp }}℃</span>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    main_title: {
      type: String,
      default: "",
    },
    // isT: {
    //   type: Number,
    //   default: "",
    // },
  },
  data() {
    return {
      time: "",
      now: "",
      weatherInfo: {}, //天气信息
      city: "",
      img_src: "",
      day: "",
    };
  },
  watch: {
    day(newVal) {
      this.getWeather();
    },
  },
  mounted() {
    this.getTime();
    this.getWeather();
    // this.s_titleFormat();
    this.time = setInterval(() => {
      this.getTime();
    }, 1000);
  },
  destroyed() {
    clearInterval(this.time);
    this.time = "";
  },
  methods: {
    getTime() {
      var that = this;
      var date = new Date();
      var year = date.getFullYear(); //获取当前年份
      var mon = date.getMonth() + 1; //获取当前月份
      var da = date.getDate(); //获取当前日
      var day = date.getDay(); //获取当前星期几
      var h = date.getHours(); //获取小时
      var m = date.getMinutes(); //获取分钟
      var s = date.getSeconds(); //获取秒

      if (mon < 10) mon = "0" + mon;
      if (da < 10) da = "0" + da;

      if (h < 10) h = "0" + h;
      if (m < 10) m = "0" + m;
      if (s < 10) s = "0" + s;

      var weekday = "";
      if (day == 0) weekday = " 星期日";
      else if (day == 1) weekday = " 星期一";
      else if (day == 2) weekday = " 星期二";
      else if (day == 3) weekday = " 星期三";
      else if (day == 4) weekday = " 星期四";
      else if (day == 5) weekday = " 星期五";
      else if (day == 6) weekday = " 星期六";
      that.day = da;
      that.now =
        year +
        "年" +
        mon +
        "月" +
        da +
        "日" +
        weekday +
        " " +
        h +
        ":" +
        m +
        ":" +
        s;
    },
    getWeather() {
      var that = this;
      this.$axios
        .get(
          "https://restapi.amap.com/v3/weather/weatherInfo?key=e30679c6b10da250f88fa18ce9d89974&city=杭州&extensions=all"
        )
        .then(function (res) {
          // console.log(res);
          that.weatherInfo = res.data.forecasts[0].casts[0];
          that.city = res.data.forecasts[0].city;
          // that.img_type = res.data.data[0].wea_img;
          // that.img_src = require("../../public/banana/" +
          //   res.data.data[0].wea_img +
          //   ".png");
        })
        .catch(() => {});
    },
  },
};
</script>

<style lang="less" scoped>
.headContainer {
  position: absolute;
  left: 0;
  top: 0;
  right: 0;
  background: url("../../src/assets/headBar.png") no-repeat;
  background-size: 100% 100%;
  height: 135px;
  padding: 0 8%;
  color: #00eeff;
  font-size: 14px;
  z-index: 2;
  .headCon {
    height: 86px;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  // 时间
  .time {
    width: 20%;
    text-align: center;

    margin-left: -3%;
        margin-top: 1%
  }
  // center
  .center {
    // width: 24%;
    .center_top {
      display: flex;
      justify-content: space-around;
      align-items: center;
      img{
        display: block;
      }
      .logo {
        width: 139px;
        margin-right: 1.5%;
      }
      .main_title {
        // width: 220px;
        margin-left: 1.5%;
      }
    }
  }
  //天气
  .weather {
    width: 20%;
    box-sizing: border-box;

    margin-right: -5%;
    margin-top: 1%;
    span {
      margin-right: 2%;
    }
    span:first-child {
      margin-right: 0;
    }
    img {
      height: 30%;
    }
  }
}
</style>
